import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { NgbModal, NgbModalOptions, NgbModalRef, NgbModalUpdatableOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-form',
  standalone: true,
  templateUrl: './modal-form.component.html',
  styleUrls: ['../modal.component.scss'],
  imports: [CommonModule],
})
export class ModalFormComponent implements OnInit {
  @ViewChild('modal') private modalContent: TemplateRef<ModalFormComponent>;
  private modalRef: NgbModalRef;

  @Input() public modalConfig: ModalConfig;
  @Input() public modalOptions: NgbModalOptions;

  defaultOptions: NgbModalOptions = {
    centered: true,
    backdrop: 'static',
    keyboard: false,
  };

  defaultConfig: ModalConfig = {
    showHeader: true,
  };

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.modalConfig = {
      ...this.defaultConfig,
      ...this.modalConfig,
    };
  }

  open(): Promise<boolean> {
    const opts = typeof this.modalOptions === 'undefined' ? this.defaultOptions : { ...this.modalOptions, ...this.defaultOptions };
    return new Promise<boolean>((resolve) => {
      this.modalRef = this.modalService.open(this.modalContent, opts);
      this.modalRef.result.then(resolve, resolve);
    });
  }

  /**
   * Meneruskan pembaruan opsi ke `NgbModalRef` selagi modal masih terbuka.
   *
   * Dipakai untuk menukar `windowClass`/`backdropClass` — mis. menyembunyikan modal saat
   * sub-modal menggantikannya — tanpa menutup dan membuka ulang modal, sehingga data yang
   * sudah dimuat tetap utuh.
   */
  update(options: NgbModalUpdatableOptions): void {
    this.modalRef?.update(options);
  }

  async close(): Promise<void> {
    if (this.modalConfig.shouldClose === undefined || (await this.modalConfig.shouldClose())) {
      const result = this.modalConfig.onClose === undefined || (await this.modalConfig.onClose());
      this.modalRef.close(result);
    }
  }

  async dismiss(): Promise<void> {
    if (this.modalConfig.shouldDismiss === undefined || (await this.modalConfig.shouldDismiss())) {
      const result = this.modalConfig.onDismiss === undefined || (await this.modalConfig.onDismiss());
      this.modalRef.dismiss(result);
    }
  }
}
